import { useSyncExternalStore } from "react";

import { generationSettingStore } from "../store/SettingsGenerationSettingStore";
import type { ElementSettingMap } from "../SettingsPayload";

/** 要素の設定を丸ごと購読する。名前の解決など、複数件を横断する表示で使う。 */
export function useElements(): ElementSettingMap {
    return useSyncExternalStore(
        (cb: () => void) => generationSettingStore.subscribeElements(cb),
        () => generationSettingStore.getElements(),
        () => generationSettingStore.getElements()
    );
}
